import { useEffect, useMemo } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $countryStore } from '@lib/store';
import { type RecipientResponse, TransferRecipientTypeEnum } from '@shared/api/rest/recipients';
import { Table, TableCellType } from '@shared/widgets';

interface RecipientsTableProps {
  data: RecipientResponse[];
  isLoading?: boolean;
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
  setSelectedItemId: (data: string) => void;
}

export const RecipientsTable = (props: RecipientsTableProps) => {
  const countryStore = useUnit($countryStore.store);

  const { t } = useTranslation('payments');

  useEffect(() => {
    $countryStore.events.update();
  }, []);

  const columns = useMemo(
    () => [
      t('recipients.columns.name'),
      t('recipients.columns.typeRecipient'),
      t('recipients.columns.accountIbanNumber'),
      t('recipients.columns.country'),
      t('recipients.columns.currency'),
    ],
    [t],
  );
  return (
    <Table
      isLoading={props.isLoading}
      columns={columns}
      items={props.data.map((row) => {
        return [
          {
            type: TableCellType.Text,
            value: row.type === TransferRecipientTypeEnum.Business ? row.companyName : `${row.firstName || ''} ${row.lastName || '-'}`,
          },
          { type: TableCellType.Text, value: t(`recipientType.${row.type.toLowerCase()}`, { ns: 'common' }) },
          { type: TableCellType.Text, value: row.iban || row.accountNumber || '-' },
          { type: TableCellType.Text, value: countryStore.data.find((c) => c.twoLetterCode === row.countryCode)?.name || '' },
          { type: TableCellType.Text, value: row.currency },
        ];
      })}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
      onClick={(rowIndex) => props.setSelectedItemId(props.data[rowIndex].id)}
      isScrollable
    />
  );
};
